import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { exportToExcel } from "../../../core/common/GlobalFunctions/exportTableData";
import { exportToCSV } from "../../../core/common/GlobalFunctions/exportTableData";
import ReactApexChart from "react-apexcharts";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAllSalaryReportDetailsByDepartment, fetchAllSalaryReportDetailsByDepartmentCount, fetchAllSalaryReportDetailsByDepartmentCountMonthly } from "../../../core/data/redux/reports/salary_report/salary_report.Action";
interface SalaryReportProps {
    showOnlyTable?: boolean;
}

const SalaryReport: React.FC<SalaryReportProps> = ({ showOnlyTable }) => {
    const [selectedYear, setSelectedYear] = useState("2025");
    const [selectedSort, setSelectedSort] = useState<any>("Recently Added");
    const [selectedDepartment, setSelectedDepartment] = useState<string>('ALL');
    const [salaryData, setSalaryData] = useState<any[]>([]);
    const { departments } = useSelector((state: any) => state.department);
    const dispatch = useDispatch<AppDispatch>();
    const [list, setlist] = useState<any>(null);
    const [details, setdetails] = useState<any>(null);
    const [monthlyDetails, setmonthlyDetails] = useState<any>(null);
    const [tableKey, setTableKey] = useState(0);



    const getCurrentMonthDates = () => {
        const now = new Date();

        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        const format = (date: Date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        };

        return {
            startDate: format(start),
            endDate: format(end),
        };
    };





    const { startDate: defaultStartDate, endDate: defaultEndDate } =
        getCurrentMonthDates();


    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(defaultEndDate);
    const [chartKey, setChartKey] = useState(0);


    useEffect(() => {
        if (selectedYear) {

        }
    }, [dispatch, selectedYear]);


    useEffect(() => {
        if (departments.length === 0) {
            dispatch(fetchAllDepartments());
        }
    }, []);


    const data = salaryData || [];

    const EXCLUDED_KEYS = [
        "CreatedAt",
        "ModifiedAt",
        "CreatedBy",
        "ModifiedBy",
        "transaction_id",
        "employee_id",
        "salary_structure_id",
        "overtime_pay_id",
        "PictureURL",
    ];


    const formatSalaryDataForExport = (data: any[]) => {
        return data.map((item) => {
            const row: any = {};

            Object.keys(item).forEach((key) => {
                if (EXCLUDED_KEYS.includes(key)) return;

                const value = item[key];
                if (Array.isArray(value)) return;

                const columnName = key
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (c) => c.toUpperCase());

                row[columnName] = value ?? "";
            });

            if (Array.isArray(item.earnings_json)) {
                item.earnings_json.forEach((earning: any) => {
                    row[`Earning - ${earning.name}`] = earning.amount ?? 0;
                });
            }
            if (Array.isArray(item.deductions_json)) {
                item.deductions_json.forEach((deduction: any) => {
                    row[`Deduction - ${deduction.name}`] =
                        deduction.proratedAmount ?? deduction.originalAmount ?? 0;
                });
            }

            return row;
        });
    };


    const data2 = formatSalaryDataForExport(data)

    useEffect(() => {
        setTableKey((prevKey) => prevKey + 1);
    }, [dispatch, list, data, details, selectedSort]);

    const filteredData = useMemo(() => {
        return filterData(data || [], {}, "CreatedAt", "CreatedAt", selectedSort);
    }, [data, selectedSort]);


    const handleSearch = async () => {
        try {
            const payload = {
                startDate,
                endDate,
                departmentId: selectedDepartment || "ALL",
            };

            const [listRes, countRes, monthly]: any = await Promise.all([
                dispatch(fetchAllSalaryReportDetailsByDepartment(payload)),
                dispatch(fetchAllSalaryReportDetailsByDepartmentCount(payload)),
                dispatch(fetchAllSalaryReportDetailsByDepartmentCountMonthly(payload))
            ]);

            // Table data
            setSalaryData(listRes?.payload?.data || []);
            setdetails(countRes?.payload?.data || null);
            setmonthlyDetails(monthly?.payload?.data || null)

        } catch (error) {
            console.error("Search failed", error);
        }
    };



    useEffect(() => {
        handleSearch();
    }, []);



    const transcationColumns = [
        {
            title: "Emp ID",
            dataIndex: "EmployeeNumber",
            sorter: (a: any, b: any) => a.EmployeeNumber.length - b.EmployeeNumber.length,
        },
        {
            title: "Name",
            dataIndex: "EmployeeName",
            render: (text: string, record: any) => (
                <div className="d-flex align-items-center file-name-icon">
                    <div className="avatar avatar-md">
                        <img
                            src={record.PictureURL ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                            alt="img"
                            className="img-fluid rounded-circle"
                        />
                    </div>
                    <div className="ms-2">
                        <h6 className="fw-medium">
                            <Link to="#">{record.EmployeeName}</Link>
                        </h6>
                    </div>
                </div>
            ),
            sorter: (a: any, b: any) => a.EmployeeName.length - b.EmployeeName.length,
        },

        {
            title: "Status",
            dataIndex: "status",
            sorter: (a: any, b: any) => {
                const statusOrder = ['pending', 'processed'];
                return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
            },
            render: (status: string) => {
                let color = '';
                let text = '';

                if (status === 'Processed') {
                    color = 'green';
                    text = 'Processed';
                } else if (status === 'Pending') {
                    color = 'orange';
                    text = 'Pending';
                }

                return (
                    <span style={{ color: color }}>
                        {text}
                    </span>
                );
            }
        },

        {
            title: "Leaves Taken",
            dataIndex: "leaves_taken",
            sorter: (a: any, b: any) => a.leaves_taken - b.leaves_taken,
        },
        {
            title: "Balance Leave",
            dataIndex: "balance_leave",
            sorter: (a: any, b: any) => a.balance_leave - b.balance_leave,
        },
        {
            title: "Present",
            dataIndex: "total_attendance_count",
            sorter: (a: any, b: any) => a.total_attendance_count - b.total_attendance_count,
        },
        {
            title: "Leave Deduction",
            dataIndex: "leave_deduction",
            sorter: (a: any, b: any) => a.leave_deduction - b.leave_deduction,
        },
        {
            title: "Overtime Hours",
            dataIndex: "overtime_hours",
            sorter: (a: any, b: any) => a.overtime_hours - b.overtime_hours,
            render: (text: any) => (text !== undefined && text !== null) ? text : 0,
        },

        {
            title: "Earnings",
            dataIndex: "earnings_json",
            render: (text: any) => (
                <div>
                    {text && text.length > 0 ? (
                        text.map((earning: any) => (
                            <div key={earning.id}>
                                <span>
                                    {earning?.name || "None"}: ₹{earning?.amount ? earning.amount.toLocaleString() : "0"}
                                </span>
                            </div>
                        ))
                    ) : (
                        <span>₹0</span>
                    )}
                </div>
            ),
        },
        {
            title: "Deductions",
            dataIndex: "deductions_json",
            render: (text: any) => (
                <div>
                    {text && text.length > 0 ? (
                        text.map((deduction: any) => (
                            <div key={deduction.id}>
                                <span>
                                    {deduction?.name || "None"}: ₹{deduction?.amount ? deduction.amount.toLocaleString() : "0"}
                                </span>
                            </div>
                        ))
                    ) : (
                        <span>₹0</span>
                    )}
                </div>
            ),
        },
        {
            title: "Overtime Pay",
            dataIndex: "overtime_pay",
            sorter: (a: any, b: any) => a.overtime_pay - b.overtime_pay,
            render: (text: any) => (
                <span style={{ color: "#E67E22", fontWeight: "bold" }}>
                    ₹{text?.toLocaleString()}
                </span>
            ),
        },
        {
            title: "Net Salary",
            dataIndex: "net_salary",
            sorter: (a: any, b: any) => a.net_salary - b.net_salary,
            render: (text: any) => (
                <span style={{ color: "#27AE60", fontWeight: "bold" }}>
                    ₹{text?.toLocaleString()}
                </span>
            ),
        },

    ];


    useEffect(() => {
        const netPayablePerMonth = new Array(12).fill(0);

        if (monthlyDetails && monthlyDetails.length > 0) {
            monthlyDetails.forEach(({ month, total_net_salary }: any) => {
                netPayablePerMonth[month - 1] = Number(total_net_salary);
            });
        }

        setpayslipchart((prev: any) => ({
            ...prev,
            series: [
                {
                    ...prev.series[0],
                    data: netPayablePerMonth,
                },
            ],
        }));

        setChartKey(prev => prev + 1);
    }, [monthlyDetails]);


    const [payslipchart, setpayslipchart] = useState<any>({
        series: [
            {
                name: "Net Salary",
                data: new Array(12).fill(0),
            },
        ],
        chart: {
            type: "area",
            height: 215,
            toolbar: { show: false },
        },
        xaxis: {
            categories: [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
            ],
        },
        stroke: {
            curve: "smooth",
            width: 2,
        },
        dataLabels: {
            enabled: false,
        },
        fill: {
            opacity: 0.4,
        },
        tooltip: {
            y: {
                formatter: (val: number) => `₹ ${val.toLocaleString()}`,
            },
        },
        colors: ["#FF5733"],
    });



    // if (showOnlyTable) {
    //     return (
    //         <Table
    //             key={tableKey}
    //             dataSource={filteredData}
    //             columns={transcationColumns}
    //             Selection={false}
    //         />
    //     );
    // }
    return (
        <>
            {/* Page Wrapper */}
            <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Salary Report</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to="index.html">
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">HR</li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Salary Report
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                            <div className="mb-2">
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i className="ti ti-file-export me-1" />
                                        Export
                                    </Link>
                                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                                        <li>
                                            <button
                                                onClick={() => exportToCSV(data2, "Salary_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-pdf me-1" />
                                                Export as CSV
                                            </button>
                                        </li>
                                        <li>
                                            <button
                                                onClick={() => exportToExcel(data2, "Salary_report")}
                                                className="dropdown-item rounded-1"
                                            >
                                                <i className="ti ti-file-type-xls me-1" />
                                                Export as Excel{" "}
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                    </div>
                    {/* /Breadcrumb */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row align-items-end g-2">
                                        <div className="col-md-3">
                                            <label className="form-label">Start Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                            />
                                        </div>

                                        <div className="col-md-3">
                                            <label className="form-label">End Date</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                            />
                                        </div>


                                        <div className="col-md-3">
                                            <label className="form-label">Department</label>
                                            <select
                                                className="form-select"
                                                value={selectedDepartment}
                                                onChange={(e) => setSelectedDepartment(e.target.value)}
                                            >
                                                <option value="">All Departments</option>
                                                {departments?.map((dept: any) => (
                                                    <option key={dept.Id} value={dept.Id}>
                                                        {dept.Name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="col-md-3">
                                            <button
                                                className="btn btn-primary w-100"
                                                onClick={handleSearch}
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 d-flex">
                            <div className="row flex-fill">
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Earning
                                                    </span>
                                                    <h5>
                                                        {details?.total_earnings || "00:00"}
                                                    </h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-primary border border-primary"
                                                >
                                                    <span className="text-primary">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                            {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +20.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Deductions
                                                    </span>
                                                    <h5>{details?.total_deductions || "00:00"}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-danger border border-danger"
                                                >
                                                    <span className="text-danger">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                            {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +17.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Overtime Pay
                                                    </span>
                                                    <h5>{details?.overtime_pay || "00-00"}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-success border border-success"
                                                >
                                                    <span className="text-success">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                            {/* <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                <span className="text-success fs-12 d-flex align-items-center me-1">
                                                    <i className="ti ti-arrow-wave-right-up me-1" />
                                                    +10.01%
                                                </span>{" "}
                                                from last week
                                            </p> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 d-flex">
                                    <div className="card flex-fill">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between bg-light border rounded p-2 mb-2">
                                                <div className="">
                                                    <span className="fs-14 fw-normal text-truncate mb-1">
                                                        Leave deduction
                                                    </span>
                                                    <h5>{details?.leave_deduction || '00:00'}</h5>
                                                </div>
                                                <Link
                                                    to="#"
                                                    className="avatar avatar-md avatar-rounded bg-transparent-skyblue border border-skyblue"
                                                >
                                                    <span className="text-skyblue">
                                                        <i className="ti ti-brand-shopee" />
                                                    </span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-6 d-flex">
                            <div className="card flex-fill">
                                <div className="card-header border-0 pb-0">
                                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                                        <div className="d-flex align-items-center ">
                                            <span className="me-2">
                                                <i className="ti ti-chart-area-line text-danger" />
                                            </span>
                                            <h5>Net Salary</h5>
                                        </div>

                                    </div>
                                </div>
                                <div className="card-body py-0">
                                    <ReactApexChart
                                        key={chartKey}
                                        id="payslip-chart"
                                        options={payslipchart}
                                        series={payslipchart.series}
                                        type="line"
                                        height={215}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                            <h5>Salary List</h5>
                            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                                <div className="me-3"></div>
                                <div className="dropdown">
                                    <Link
                                        to="#"
                                        className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                                        data-bs-toggle="dropdown"
                                    >
                                        {selectedSort
                                            ? `Sort By : ${selectedSort}`
                                            : "Sort By : Last 7 Days"}
                                    </Link>
                                    <ul className="dropdown-menu dropdown-menu-end p-3">
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Recently Added")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Recently Added
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Ascending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Ascending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Descending")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Descending
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last Month")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last Month
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#"
                                                onClick={() => setSelectedSort("Last 7 Days")}
                                                className="dropdown-item rounded-1"
                                            >
                                                Last 7 Days
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0">
                            <Table
                                key={tableKey}
                                dataSource={filteredData}
                                columns={transcationColumns}
                                Selection={false}
                            />
                        </div>
                    </div>
                </div>
                <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                    <p className="mb-0">2024 - 2025© hrmtree.</p>
                    <p>
                        Developed By{" "}
                        <Link to="#" className="text-primary">
                            Leadchain Systems
                        </Link>
                    </p>
                </div>
            </div>
            {/* /Page Wrapper */}
        </>
    );
};

export default SalaryReport;
